import { fromJS, Map as IMap } from 'immutable';
import { createHash } from 'crypto';
import promoErrorMessage from '../promotion/PromoErrorMessages';


function md5(input) {
    return createHash('md5').update(input).digest('hex');
}


export const PROMO_STORE_KEY = 'promo';
export const ACTIVE_PROMO = 'activePromo';
export const DEFAULT_PROMO_CODE = 'defaultPromoCode';
export const PROMO_ERROR = 'promoError';
export const PROMO_BY_CODE_REQUEST_STATE = 'promoByCodeRequestState';
export const REJECTED_PROMO_CODE = 'rejectedPromoCode';
export const PROMO_REWARDS = 'rewards';
export const PROMO_REWARDS_STATE = 'requestState';
export const ACCESSORY_PROMO_REWARDS = 'promotionalAccessoryData';
export const PROMO_STATUS = 'promoStatus';
export const DISCOUNT_PROMO_REWARD = 'totalDiscountRewardAmount';
export const REJECTED_PROMO = 'rejectedPromoCode';
export const CUSTOM_REWARD_CARD_RECIPIENT_STORE_KEY = 'customRewardRecipients';
export const PROMO_LIMIT_EXCEEDED = 'promoLimitExceeded';
export const SHOW_BANNER = 'showBanner';
export const DIGITAL_PROMO_REWARD_CARDS = 'electronicRewardCards';
export const PLASTIC_PROMO_REWARD_CARDS = 'physicalRewardCards';
export const RECIPIENT_CHOICE_FIELD = 'recipientChoice';
export const PROMO_SELF_BONUS_KEY = 'selfBonus';
export const REWARD_EMAIL = 'email';
export const REWARD_RECIPIENT_NAME = 'recipient_name';
export const PROMO_RECIPIENT_FIELDS = {
    RECIPIENT_NAME: 'recipientName',
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    EMAIL: 'email',
    PHONE: 'phoneNumber',
    STREET1: 'street1',
    STREET2: 'street2',
    CITY: 'city',
    STATE: 'state',
    ZIP_CODE: 'postalCode',
    COUNTRY_CODE: 'countryCode'
};
export const REWARDS_REQUEST_STATE = {
    ACTIVE: 'active',
    FAILED: 'failed',
    SUCCESS: 'success'
};
export const PROMO_CERT_TYPE = {
    DIGITAL: 'ELEC',
    PHYSICAL: 'PLST'
};

export const INVALID_PROMO_ERROR = 'promo_invalid';
export const EXPIRED_PROMO_ERROR = 'promo_expired';
export const SOLD_OUT_PROMO_ERROR = 'promo_sold_out';
export const PROMO_VALID_SUCCESS = 'promo_valid_success';
export const PROMO_ERROR_RESPONSES = {
    PROMO_EXHAUSTED: 'PROMO_EXHAUSTED'
};
export const PROMO_NUDGES = 'promoNudges';
export const NUDGE_SEEN = 'nudgeSeen';
export const SHIPPING_PROMO_REWARDS = 'promotionalShippingData';
export const GET_PROMO_NUDGE_CONFIG_DATA = '@@storefront/GET_PROMO_NUDGE_CONFIG_DATA';
export const PROMO_NUDGE_SUCCESS = '@@storefront/PROMO_NUDGE_SUCCESS';
export const PROMO_NUDGE_FAILED = '@@storefront/PROMO_NUDGE_FAILED';


export const GET_INITIAL_PROMO = '@@storefront/GET_INITIAL_PROMO';
export const APPLY_ACTIVE_PROMO = '@@storefront/APPLY_PROMO';
export const GET_PROMO_FOR_CODE = '@@storefront/GET_PROMO_FOR_CODE';
export const RESET_PROMO = '@@storefront/RESET_PROMO';
export const RECEIVED_PROMO_REWARDS = '@@storefront/RECEIVED_PROMO_REWARDS';


export const SET_ACTIVE_PROMO = '@@storefront/SET_ACTIVE_PROMO';
export const SET_DEFAULT_PROMO_CODE = '@@storefront/SET_DEFAULT_PROMO_CODE';
export const SET_PROMO_ERROR = '@@storefront/SET_PROMO_ERROR';
export const SET_PROMO_BY_CODE_REQUEST_STATE = '@@storefront/SET_PROMO_BY_CODE_REQUEST_STATE';
export const SET_REJECTED_PROMO = '@@storefront/SET_REJECTED_PROMO';
export const SET_PROMO_REWARDS = '@@storefront/SET_PROMO_REWARDS';
export const SET_REWARDS_REQUEST_STATE = '@@storefront/SET_REWARDS_REQUEST_STATE';
export const SET_PROMO_STATUS = '@@storefront/SET_PROMO_STATUS';
export const CLEAR_REJECTED_PROMOS = '@@storefront/CLEAR_REJECTED_PROMO';
export const REMOVE_PROMO_REWARDS = '@@storefront/REMOVE_PROMO_REWARDS';
export const CLEAR_CUSTOM_REWARD_CARD_RECIPIENT = '@@storefront/CLEAR_CUSTOM_REWARD_CARD_RECIPIENT';
export const SET_PROMO_LIMIT_EXCEEDED = '@@storefront/SET_PROMO_LIMIT_EXCEEDED';
export const SET_SHOW_BANNER = '@@storefront/SHOW_BANNER';
export const SET_PROMO_DISCOUNT_AMOUNT = '@@storefront/SET_PROMO_DISCOUNT_AMOUNT';
export const SET_CUSTOM_REWARD_CARD_RECIPIENT = '@@storefront/SET_CUSTOM_REWARD_CARD_RECIPIENT';
export const SET_CUSTOM_REWARD_CARD_RECIPIENT_EMAIL = '@@storefront/SET_CUSTOM_REWARD_CARD_RECIPIENT_EMAIL';
export const SET_CUSTOM_REWARD_CARD_RECIPIENT_NAME = '@@storefront/SET_CUSTOM_REWARD_CARD_RECIPIENT_NAME';
export const UPDATE_CUSTOM_REWARD_CARD_SENDER = '@@storefront/UPDATE_CUSTOM_REWARD_CARD_SENDER';
export const SET_SHIPPING_COST_DATA = '@@storefront/SET_SHIPPING_COST_DATA';

export const initialState = IMap();



export default function promoReducer(state = initialState, action) {
    switch (action.type) {
        case SET_ACTIVE_PROMO: {
            return state.set(ACTIVE_PROMO, fromJS(action.promo));
        }
        case SET_DEFAULT_PROMO_CODE: {
            return state.set(DEFAULT_PROMO_CODE, action.promoCode);
        }
        case SET_PROMO_ERROR: {
            const { codeOrDefault, error } = action;
            return state.update(PROMO_ERROR, (errorMap = IMap()) => errorMap.merge({ [codeOrDefault]: error }));
        }
        case SET_PROMO_BY_CODE_REQUEST_STATE: {
            return state.set(PROMO_BY_CODE_REQUEST_STATE, action.state);
        }
        case SET_REJECTED_PROMO: {
            
            const stateWithoutActivePromo = state.delete(ACTIVE_PROMO);
            return stateWithoutActivePromo.set(REJECTED_PROMO_CODE, fromJS(action.rejectedPromoCode));
        }
        case SET_PROMO_REWARDS: {
            return state
                .set(PROMO_REWARDS,
                    fromJS(action.rewards).merge({ [PROMO_REWARDS_STATE]: REWARDS_REQUEST_STATE.SUCCESS }));
        }
        case SET_REWARDS_REQUEST_STATE: {
            return state.setIn([PROMO_REWARDS, PROMO_REWARDS_STATE], action.state);
        }
        case SET_PROMO_STATUS: {
            return state.set(PROMO_STATUS, fromJS(action.status));
        }
        case CLEAR_REJECTED_PROMOS: {
            return state
                .delete(PROMO_ERROR)
                .delete(REJECTED_PROMO_CODE);
        }
        case REMOVE_PROMO_REWARDS: {
            return state.delete(PROMO_REWARDS);
        }
        case CLEAR_CUSTOM_REWARD_CARD_RECIPIENT: {
            return state.delete(CUSTOM_REWARD_CARD_RECIPIENT_STORE_KEY);
        }
        case SET_PROMO_LIMIT_EXCEEDED: {
            return state.set(PROMO_LIMIT_EXCEEDED, fromJS(action.status));
        }
        case SET_SHOW_BANNER: {
            return state.set(SHOW_BANNER, fromJS(action.status));
        }
        case SET_PROMO_DISCOUNT_AMOUNT: {
            return state.setIn([PROMO_REWARDS, DISCOUNT_PROMO_REWARD], action.amount);
        }
        case SET_CUSTOM_REWARD_CARD_RECIPIENT: {
            const { parentCardCartToken, recipientData } = action;
            return state.setIn([CUSTOM_REWARD_CARD_RECIPIENT_STORE_KEY, parentCardCartToken], recipientData);
        }
        case SET_CUSTOM_REWARD_CARD_RECIPIENT_EMAIL: {
            return state.setIn(
                [CUSTOM_REWARD_CARD_RECIPIENT_STORE_KEY,
                    action.parentCardCartToken, REWARD_EMAIL],
                action.recipientEmail
            );
        }
        case SET_CUSTOM_REWARD_CARD_RECIPIENT_NAME: {
            return state
                .setIn(
                    [CUSTOM_REWARD_CARD_RECIPIENT_STORE_KEY,
                        action.parentCardCartToken, REWARD_RECIPIENT_NAME],
                    action.recipientName
                )
                .setIn(
                    [CUSTOM_REWARD_CARD_RECIPIENT_STORE_KEY,
                        action.parentCardCartToken, 'recipientName'],
                    action.recipientName
                );
        }
        case UPDATE_CUSTOM_REWARD_CARD_SENDER: {
            const { updatedMap } = action;
            return state.set(CUSTOM_REWARD_CARD_RECIPIENT_STORE_KEY, updatedMap);
        }
        case SET_SHIPPING_COST_DATA: {
            return state.set('shippingCostData', fromJS(action.payload));
        }
        case PROMO_NUDGE_SUCCESS: {
            let hasNudges = action.payload
                && action.payload.nudges
                && action.payload.nudges.length > 0;
            hasNudges = state.get(NUDGE_SEEN, false) ? true : hasNudges;
            return state
                .set(PROMO_NUDGES, action.payload)
                .set(NUDGE_SEEN, hasNudges);
        }
        default:
            return state;
    }
}


export const getInitialPromo = () => ({
    type: GET_INITIAL_PROMO
});

export function setDefaultPromoCode(promoCode) {
    return {
        type: SET_DEFAULT_PROMO_CODE,
        promoCode
    };
}

export function setPromo(promo) {
    return {
        type: SET_ACTIVE_PROMO,
        promo
    };
}

export function clearActivePromo() {
    return {
        type: SET_ACTIVE_PROMO,
        promo: {}
    };
}

export function setPromoError(codeOrDefault, error) {
    return {
        type: SET_PROMO_ERROR,
        codeOrDefault,
        error
    };
}

export const setPromoByCodeRequestState = requestState => ({
    type: SET_PROMO_BY_CODE_REQUEST_STATE,
    state: requestState
});

export const setRejectedPromo = rejectedPromoCode => ({
    type: SET_REJECTED_PROMO,
    rejectedPromoCode
});

export const setPromoRewards = (rewards, segmentPromoData) => ({
    type: SET_PROMO_REWARDS,
    rewards,
    meta: {
        segment: {
            event: 'track',
            eventAction: `Promo Applied`,
            eventData: segmentPromoData
        }
    }
});

export const setRewardsRequestActive = () => ({
    type: SET_REWARDS_REQUEST_STATE,
    state: REWARDS_REQUEST_STATE.ACTIVE
});

export const setRewardsRequestFailure = () => ({
    type: SET_REWARDS_REQUEST_STATE,
    state: REWARDS_REQUEST_STATE.FAILED
});

export const applyActivePromo = () => ({
    type: APPLY_ACTIVE_PROMO
});

export const getPromoForCode = (promoCode, isManual = false) => ({
    type: GET_PROMO_FOR_CODE,
    promoCode,
    isManual
});

export function setPromoStatus(status) {
    return {
        type: SET_PROMO_STATUS,
        status
    };
}

export function resetPromo() {
    return {
        type: RESET_PROMO
    };
}

export const clearRejectedPromos = () => ({
    type: CLEAR_REJECTED_PROMOS
});

export function clearPromoStatus() {
    return {
        type: SET_PROMO_STATUS,
        status: null
    };
}

export const removePromoRewards = () => ({
    type: REMOVE_PROMO_REWARDS
});

export const removeCustomRewardCardRecipients = () => ({
    type: CLEAR_CUSTOM_REWARD_CARD_RECIPIENT
});


export const setPromoLimitExceeded = status => ({
    type: SET_PROMO_LIMIT_EXCEEDED,
    status
});

export function setShowBanner(status) {
    return {
        type: SET_SHOW_BANNER,
        status
    };
}

export function setPromoDiscountAmount(amount) {
    return {
        type: SET_PROMO_DISCOUNT_AMOUNT,
        amount
    };
}


export const setCustomRewardCardRecipientForPromo = (parentCardCartToken, recipientData) => ({
    type: SET_CUSTOM_REWARD_CARD_RECIPIENT,
    parentCardCartToken,
    recipientData
});


export function getPromoRecipientHash(reward) {
    const recipient = reward.get('recipient');
    const hashString = `${recipient.get('first_name')}
    ${recipient.get('last_name')}
    ${recipient.get('recipient_name')}
    ${recipient.get('full_name')}
    ${recipient.get('email')}
    ${recipient.get('street')}
    ${recipient.get('street2')}
    ${recipient.get('city')}
    ${recipient.get('state')}
    ${recipient.get('zip_code')}
    ${recipient.get('phone')}
    ${recipient.get('country_code')}`;
    return md5(hashString.replace(/\s/g, '').toLowerCase());
}

/**
 * Sets the rewards customRecipient email
 * @param {string} parentCardCartToken: the cart token that needs to be updated
 * @param {string} recipientEmail: the new email that will be stored for the reward card
 * @returns {Object} Action object signalling to set the rewards recipient email with new email
 */
export const setCustomRewardCardRecipientEmailForPromo = (parentCardCartToken, recipientEmail) => ({
    type: SET_CUSTOM_REWARD_CARD_RECIPIENT_EMAIL,
    parentCardCartToken,
    recipientEmail
});

/**
 * Sets the rewards customRecipient recipient name
 * @param {string} parentCardCartToken: the cart token that needs to be updated
 * @param {string} recipientName: the new recipient name that will be stored for the reward card
 * @returns {Object} Action object signalling to set the rewards recipient name with new name
 */
export const setCustomRewardCardRecipientNameForPromo = (parentCardCartToken, recipientName) => ({
    type: SET_CUSTOM_REWARD_CARD_RECIPIENT_NAME,
    parentCardCartToken,
    recipientName
});

export function getPromoNudgeData(promoCode, cartAmount, cardAmount) {
    return {
        type: GET_PROMO_NUDGE_CONFIG_DATA,
        promoCode,
        cartAmount,
        cardAmount
    };
}


export function getPromoNudgeConfigSuccess(payload) {
    return {
        type: PROMO_NUDGE_SUCCESS,
        payload
    };
}

export function getPromoNudgeConfigFailed() {
    return {
        type: PROMO_NUDGE_FAILED
    };
}

export const validateStatusType = (showStatus, statusType, promoCode, intl) => {
    // Don't need validation right now, always pass.
    const nullValidator = () => {};
    if (!showStatus) {
        return nullValidator;
    }

    
    return () => {
        switch (statusType) {
            case PROMO_VALID_SUCCESS:
                return null;
            case EXPIRED_PROMO_ERROR:
                return intl.formatMessage(promoErrorMessage.offerExpiredText, { promoCode });
            case SOLD_OUT_PROMO_ERROR:
                return intl.formatMessage(promoErrorMessage.promoSoldOutBody, { promoCode });
            case PROMO_ERROR_RESPONSES.PROMO_EXHAUSTED:
                return intl.formatMessage(promoErrorMessage.promoExhaustedInlineBody, { promoCode });
            case INVALID_PROMO_ERROR:
            default:
                return intl.formatMessage(promoErrorMessage.invalidPromoCodeText, { promoCode });
        }
    };
};


export const setShippingCostData = shippingCostData => ({
    type: SET_SHIPPING_COST_DATA,
    payload: shippingCostData
});

export const finishedGettingPromoRewards = (capiClient, requestData) => ({
    type: RECEIVED_PROMO_REWARDS,
    payload: { capiClient, requestData }
});
